import { useState } from 'react';
import './model-data.css';
import { ModelData as ModelDataData } from '../model-space-ref-exposer/model-space-ref-exposer';
import * as THREE from 'three';

type ModelDataProps = {
    visible: boolean;
    data?: ModelDataData;
    onlyPosition?: boolean;
    onChange: (data: ModelDataData) => void;
    onInputFocus?: () => void;
    onInputFocusLose?: () => void;
};

export const ModelData = ({ visible, data, onlyPosition = false, onChange, onInputFocus, onInputFocusLose }: ModelDataProps) => {
    const [values, setValues] = useState<ModelDataData | undefined>(data);
    const [prevData, setPrevData] = useState<ModelDataData>();
    
    if (!visible) return null;

    const handleInputChange = (name: keyof ModelDataData, value: string) => {
        setValues({
            ...values,
            [name]: value
        });

        if (value !== '' && !isNaN(parseFloat(value))) {
            onChange({
                [name]: parseFloat(value)
            });
        }
    };

    if (data) {
        if (data.xPosition !== prevData?.xPosition ||
            data.yPosition !== prevData?.yPosition ||
            data.zPosition !== prevData?.zPosition ||
            data.xRotation !== prevData?.xRotation ||
            data.yRotation !== prevData?.yRotation ||
            data.zRotation !== prevData?.zRotation ||
            data.xScale !== prevData?.xScale ||
            data.yScale !== prevData?.yScale ||
            data.zScale !== prevData?.zScale
        ) {
            setPrevData({
                ...prevData,
                ...data
            });
            setValues({
                ...values,
                ...data
            });
        }
    }

    const header = (
        <h5>Kijelölt elem adatai:</h5>
    );
    
    const position = (
        <div className='position'>
            <b>Pozició:</b>
            &nbsp;
            X:
            <input
                type='number'
                value={values?.xPosition}
                onChange={(e) => handleInputChange('xPosition', e.target.value)}
                className='box-shadow-4-4-8-0 border-0'
                onFocus={onInputFocus}
                onBlur={onInputFocusLose}
            />
            &nbsp;
            Y:
            <input
                type='number'
                value={values?.yPosition}
                onChange={(e) => handleInputChange('yPosition', e.target.value)}
                className='box-shadow-4-4-8-0 border-0'
                onFocus={onInputFocus}
                onBlur={onInputFocusLose}
            />
            &nbsp;
            Z:
            <input
                type='number'
                value={values?.zPosition}
                onChange={(e) => handleInputChange('zPosition', e.target.value)}
                className='box-shadow-4-4-8-0 border-0'
                onFocus={onInputFocus}
                onBlur={onInputFocusLose}
            />
        </div>
    );

    const rotation = (
        <div className='rotation'>
            <b>Rotáció:</b>
            &nbsp;
            X:
            <input
                type='number'
                value={(values?.xRotation === undefined || values?.xRotation === null) ? '' : THREE.MathUtils.radToDeg(values?.xRotation)}
                onChange={(e) => handleInputChange('xRotation', e.target.value)}
                className='box-shadow-4-4-8-0 border-0'
                onFocus={onInputFocus}
                onBlur={onInputFocusLose}
            />
            &nbsp;
            Y:
            <input
                type='number'
                value={(values?.yRotation === undefined || values?.yRotation === null) ? '' : THREE.MathUtils.radToDeg(values?.yRotation)}
                onChange={(e) => handleInputChange('yRotation', e.target.value)}
                className='box-shadow-4-4-8-0 border-0'
                onFocus={onInputFocus}
                onBlur={onInputFocusLose}
            />
            &nbsp;
            Z:
            <input
                type='number'
                value={(values?.zRotation === undefined || values?.zRotation === null) ? '' : THREE.MathUtils.radToDeg(values?.zRotation)}
                onChange={(e) => handleInputChange('zRotation', e.target.value)}
                className='box-shadow-4-4-8-0 border-0'
                onFocus={onInputFocus}
                onBlur={onInputFocusLose}
            />
        </div>
    );

    const scale = (
        <div className='position'>
            <b>Scale(méretarány):</b>
            &nbsp;
            X:
            <input
                type='number'
                value={values?.xScale}
                onChange={(e) => handleInputChange('xScale', e.target.value)}
                className='box-shadow-4-4-8-0 border-0'
                onFocus={onInputFocus}
                onBlur={onInputFocusLose}
            />
            &nbsp;
            Y:
            <input
                type='number'
                value={values?.yScale}
                onChange={(e) => handleInputChange('yScale', e.target.value)}
                className='box-shadow-4-4-8-0 border-0'
                onFocus={onInputFocus}
                onBlur={onInputFocusLose}
            />
            &nbsp;
            Z:
            <input
                type='number'
                value={values?.zScale}
                onChange={(e) => handleInputChange('zScale', e.target.value)}
                className='box-shadow-4-4-8-0 border-0'
                onFocus={onInputFocus}
                onBlur={onInputFocusLose}
            />
        </div>
    );
    
    if (onlyPosition) {
        return (
            <div className="model-data">
                {header}
                {position}
            </div>
        );
    }
    
    return (
        <div className="model-data">
            {header}
            {position}
            {rotation}
            {scale}
        </div>
    );
};